
export const REGULAR_SAVE_TYPE = 'widgets/save-type-regular';
export const CONTINUE_SAVE_TYPE = 'widgets/save-type-continue';
